import { render, staticRenderFns } from "./CompanyDropdown.vue?vue&type=template&id=28d14e8f&scoped=true&lang=pug&"
import script from "./CompanyDropdown.vue?vue&type=script&lang=js&"
export * from "./CompanyDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDropdown.vue?vue&type=style&index=0&id=28d14e8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d14e8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VMenu})
